//#region Libraries
import { 
    useState, 
    useReducer
} from "react";
//#endregion
//#region Styles
import { 
    ContainerForm, 
    ContentForm, 
    TitleForm } from "components/styles";
//#endregion
//#region Components
import HelmetUTP from "components/HelmetUTP/HelmetUTP";
import BackToView from "components/BackToView/BackToView";
import ToastMessage from "components/ToastMessage/ToastMessage";
import Step1 from "./components/Steps/Step1/Step1";
import Step2 from "./components/Steps/Step2/Step2";
import StepIndexer from "components/StepIndexer/StepIndexer";
import Footer from "./components/Footer/Footer";
import AppointmentDetail from "../components/AppointmentDetail/AppointmentDetail";
//#endregion
//#region Services
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import reducer, { initialState } from "./utils/reducer/appointment.reducer";
import { 
    TYPES 
} from "./utils/reducer/appointment.actions";
import { 
    STEPS_DESCRIPTION, 
    TOAST_MUST_CORRECT_MSG 
} from "views/Asesorias/utils/constants";
import useDataRelatedToForm from "views/Asesorias/utils/hooks/useDataRelatedToForm";
//#endregionñ

const AppointmentManualLoadingForm = () => {
    //#region Reducer
    const [state, dispatch] = useReducer(reducer, initialState);
    //#endregion
    //#region States
    const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] = useState(false);
    const [mustCorrect, setMustCorrect] = useState({
        show: false,
        message: TOAST_MUST_CORRECT_MSG.INVALID_OR_INCOMPLETED
    });
    const [hiddenToastMessageSaveEventAsDraft, setHiddenToastMessageSaveEventAsDraft] = useState(true);
    //#endregion
    // Obteniendo datos de apoyo para el formulario
    const dataRelatedToForm = useDataRelatedToForm();
    //#region Functions
    const changeForm = (type, entries) => {
        dispatch({ 
            type, 
            payload: { entries }
        });
        setCanShowDialogLeavingPage(true);
    }
    const changeFormStep1 = (part, field, value, errorValue) => {
        changeForm(TYPES.SET_FORM_STEP_1, 
            { part, field, value, errorValue });
    }
    const changeFormStep2 = (part, field, value, errorValue) => {
        changeForm(TYPES.SET_FORM_STEP_2, { part, field, value, errorValue });
    }
    const toStep = step => dispatch({ type: TYPES.TO_STEP, payload: { step } });
    const toggleHiddenToastMessageSaveEventAsDraft = () => {
        setHiddenToastMessageSaveEventAsDraft(!hiddenToastMessageSaveEventAsDraft);
    }
    const changeErrors = (step, value) => {
        dispatch({
            type: ({
                1: TYPES.SET_FORM_ERRORS_STEP_1,
                2: TYPES.SET_FORM_ERRORS_STEP_2
            })[step] || null,
            payload: { value }
        });
    }
    const changeErrorText = (field, text) => {
        dispatch({
            type: TYPES.SET_ERROR_TEXT,
            payload: {
                field, text
            }
        });
    }
    //#endregion
    const { 
        currentStep, 
        form, errors, 
        errorTexts } = state;
    const views = [
        <Step1 
            changeForm={changeFormStep1} 
            form={form.step1}
            errors={errors.step1}
            errorTexts={errorTexts}
            dataRelatedToForm={dataRelatedToForm}/>,
        <Step2
            dataRelatedToForm={dataRelatedToForm}
            changeForm={changeFormStep2}
            form={form.step2}
            errors={errors.step2}/>,
        <AppointmentDetail 
            toStep={toStep}
            dataRelatedToForm={dataRelatedToForm}
            form={form}/>
    ];
    return (
        <ContainerForm>
            <HelmetUTP title="Asesorías - Carga Manual"/>
            <ToastMessage 
                message="Paso completado"
                hidden={hiddenToastMessageSaveEventAsDraft}
                toggleHidden={toggleHiddenToastMessageSaveEventAsDraft}/>
            <ToastMessage
                variant="error" 
                message={mustCorrect.message}
                hidden={!mustCorrect.show}
                toggleHidden={() => setMustCorrect({
                    ...mustCorrect, 
                    show: !mustCorrect.show
                })}/>
            <BackToView 
                text="Volver a asesorías"
                to={ABSOLUTE_PATHS.APPOINTMENT}/>
            <StepIndexer 
                descriptions={STEPS_DESCRIPTION}
                currentStep={currentStep}
            />
            <TitleForm>Creando Asesoría</TitleForm>
            <ContentForm>
                {views[currentStep - 1] || views[views.length - 1]}
            </ContentForm>
            <Footer
                nextStep={(payload) => dispatch({ type: TYPES.NEXT_STEP, payload })}
                toStep={toStep}
                form={form}
                changeErrors={changeErrors}
                changeErrorText={changeErrorText}
                errors={errors}
                currentStep={currentStep}
                setMustCorrect={setMustCorrect}
                setHiddenToastMessageSaveEventAsDraft={setHiddenToastMessageSaveEventAsDraft}
                setCanShowDialogLeavingPage={setCanShowDialogLeavingPage}
                canShowDialogLeavingPage={canShowDialogLeavingPage}
            />
        </ContainerForm>
    );
}

export default AppointmentManualLoadingForm;